let  $AHelper ={
    getDateFromString: function(dob){
        if(dob == null){
          return "";
        }
        let birthOfDate = dob.split("T")[0];
        return birthOfDate;
      }}

export { $AHelper};